<template>
  <div class="clubs-page">
    <div class="page-header">
      <img class="header-img" src="@/assets/images/clubs/header-img.png" />
      <div class="header-title">UNESCO Clubs Movement</div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Introductions" name="Introductions">
        <clubs-introductions></clubs-introductions>
      </el-tab-pane>
      <el-tab-pane label="How to establish" name="establish">
        <ClubsEstablish></ClubsEstablish>
      </el-tab-pane>
      <el-tab-pane label="A Practical Guide" name="Guide">
        <ClubsGuide @goPdf="goPdf"></ClubsGuide>
      </el-tab-pane>
      <el-tab-pane label="Global List" name="Global">
        <ClubsGlobal></ClubsGlobal>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ClubsIntroductions from "./components/ClubsIntroductions.vue";
import ClubsEstablish from "./components/ClubsEstablish.vue";
import ClubsGuide from "./components/ClubsGuide.vue";
import ClubsGlobal from "./components/ClubsGlobal.vue";
export default {
  components: {
    ClubsIntroductions,
    ClubsEstablish,
    ClubsGuide,
    ClubsGlobal,
  },
  data() {
    return {
      activeName: "Introductions",
      constants: {},
    };
  },
  methods: {
    goPdf() {
      this.activeName = 'Global';
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    },
    handleClick: () => {},
  },
};
</script>
<style scoped lang="scss">
.mobile {
  .clubs-page {
    padding-top: 50px !important;
    .header-img {
      width: 100%;
    }
    .page-content {
      .text {
        margin-top: 20px !important;
      }
      .more-btn {
        width: 60% !important;
        font-size: 16px !important;
        line-height: 20px !important;
        margin: 20px auto !important;
      }
    }
    ::v-deep .el-tabs {
      .el-tabs__header{
        padding: 0  10px !important;
      }
      .el-tabs__content {
        padding: 0 !important;
      }
      .el-tabs__nav-scroll {
        padding: 10px 0 !important;
      }
      .el-tabs__nav-next,
      .el-tabs__nav-prev, {
        margin-top: 8px;
      }
    }
  }
}
.clubs-page {
  width: 100%;
  .page-header {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .header-title {
      position: absolute;
      left: fw(205vw, pc);
      bottom: fh(36vh, pc);
      font-size: fh(48vh, pc);
      color: #ffffff;
      line-height: fh(58vh, pc);
      .header-text {
        font-size: fh(17vh, pc);
        line-height: fh(28vh, pc);
        margin-top: fh(26vh, pc);
        width: calc(100% - 10.416vw);
      }
    }
  }
  ::v-deep .el-tabs {
    width: 100%;
    .el-tabs__content {
      padding: fh(60vh, pc) fw(200vw, pc);
    }
    .el-tabs__header {
      width: 100%;
      left: 0;
      background: #ececec;
      padding: 0 fw(200vw, pc);
      margin-bottom: 0;
    }
    .el-tabs__nav-scroll {
      padding: fh(30vh, pc) 0 !important;
    }
    .el-tabs__item {
      font-size: fh(16vh, pc);
      color: #999999;
      &.is-active {
        color: #333333;
        font-size: fh(18vh, pc);
      }
    }
    .el-tabs__active-bar {
      bottom: fh(-30vh, pc);
      background: #0077d4;
    }
  }
}
</style>
